module.exports = __webpack_public_path__ + "static/media/awards_background.d3b5b3a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/awards_background.png
// module id = 1657
// module chunks = 0